<div class="card">
    <div class="card-body">
        <div class="mb-4 d-md-flex align-items-center justify-content-between">
            <div>
                <h4><span *ngIf="isEditable">Update</span><span *ngIf="!isEditable">Add New</span> Project</h4>
                <p class="new-project-sub-line">Basic info, like your name and address on this account.</p>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <form [formGroup]="formGroup" (submit)="onSubmit()">
                    <div class="row">
                        <div class="col-md-4 form-group mb-3">
                            <input type="text" [readOnly]="isEditable" placeholder="Client Name" class="form-control" formControlName="clientName">
                        </div>
                        <div class="col-md-4 form-group mb-3">
                            <input type="text" class="form-control" placeholder="Domain Name" formControlName="domain">
                        </div>
                        <div class="col-md-4 form-group mb-3">
                            <input type="text" class="form-control" placeholder="Industry" formControlName="industry">
                        </div>
                        <div class="col-md-4 form-group mb-3">
                            <input type="text" class="form-control" placeholder="Captain Email" formControlName="captainEmail">
                        </div>
                        <div class="col-md-4 form-group mb-3">
                            <input type="text" class="form-control" placeholder="Person Name" formControlName="contactPersonName">
                        </div>
                        <div class="col-md-4 form-group mb-3">
                            <input type="text" class="form-control" placeholder="Username" formControlName="userName">
                        </div>
                        <div class="col-md-4 form-group mb-3">
                            <input type="email" class="form-control" placeholder="Email" formControlName="email">
                        </div>
                         <div class="col-md-4 form-group mb-3">
                            <input type="text" class="form-control" placeholder="Contact No" formControlName="phone">
                        </div>
                        <div class="col-md-4 form-group mb-3">
                            Demo<switch formControlName="isDemoLive" class="switchBox"></switch> Live
                            <!-- <radio value="isDemo" name="isDemoLive" formControlName="isDemoLive">Is Demo</radio>
                            <radio value="isLive" name="isDemoLive" formControlName="isDemoLive">Is Live</radio> -->
                        </div>
                        <div *ngIf="!isLiveOrNot()" class="col-md-4 form-group mb-3">
                            <input type="text" placeholder="Demo Start Date" class="form-control" formControlName="demoStartDate" bsDatepicker>
                        </div>
                        <div *ngIf="isLiveOrNot()" class="col-md-4 form-group mb-3">
                            <input type="text" placeholder="Live Date" class="form-control" formControlName="liveDate" bsDatepicker>
                        </div>
                        <div class="col-md-4 form-group mb-3">
                            <input type="text" placeholder="End Date" class="form-control" formControlName="endDate" bsDatepicker>
                        </div>
                        <div class="col-md-4 form-group mb-3">
                            <checkbox single="true" formControlName="sendWhatsapp">Send Update on Whatsapp</checkbox>
                        </div>
                    </div>
                    <div class="text-end">
                        <button class="btn btn-primary ml-2" type="submit"><span *ngIf="isEditable">Update</span><span *ngIf="!isEditable">Add</span> Project</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>